/**
 * AllMeters created by karora on 28/03/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from "../app.component";

@Component({
  selector: 'all-meters',
  template: '<meter-readings></meter-readings>',
  styles: [],
})

export class AllMetersComponent implements OnInit {
  @Input()
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) return;
    document.getElementById("title").innerText = 'All Meters';
  }

}
